module.exports = __webpack_public_path__ + "static/media/thumbs-up.f91e0f04.png";